import { render, staticRenderFns } from "./VdOnline.vue?vue&type=template&id=b0f90852&scoped=true"
import script from "./VdOnline.vue?vue&type=script&lang=js"
export * from "./VdOnline.vue?vue&type=script&lang=js"
import style0 from "./VdOnline.vue?vue&type=style&index=0&id=b0f90852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f90852",
  null
  
)

export default component.exports